import React from 'react'

function Flexbox() {
  return (

    <>
    <h2>FlexBox</h2>
    <code>flx</code>
    <br/>
    <br/>
     <p>Flexbox without wrap </p>
     <code>nowrwrap</code>
     <br/>
     <br/>
     <p className='p-doc'>for more custom gaps you can use cust class for flexbox</p>
     <code>cust-flx-[gap in integer(px)]</code>
    </>

    )
}

export default Flexbox